export const REPORT_TYPES = {
	REFERRALS_REPORT: 'Referrals Report',
	EMPLOYEE_REPORT: 'Employee Report',
	BONUS_REPORT: 'Bonus Report',
};
